// extracted by mini-css-extract-plugin
module.exports = {"container":"AnnounceDoctor_container__3c1YH","usagiDoctor":"AnnounceDoctor_usagiDoctor__M-Kif","suggest":"AnnounceDoctor_suggest__1K_Xs"};